import ModuleBase, { moduleInit, ViewLayer } from "../../../../framework/core/mvvm/module_base";
import * as ProtoPokerRoom from "../../net/proto/proto_poker_room";
import NetMsgDataBase from "../../net/net_msg_data_table_base";
import ModelBase from "../../../../framework/core/mvvm/model_base";
import ChatInfoView from "./chatinfo_view";
import ChatShowEmojiView from "./chat_show_emoji_view";
import GameServer from "../../../hall/server/gameserver/game_server";
import BlackJackUtility from "../../../blackjack/Utility/blackJack_utility";
import MyemojiItem from "./my_emoji_item";
import OhterEmojiItem from "./ohter_emoji_item";
import ChatEmojiSound from "./chat_emoji_sound";
import Module from "../../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData from "../../../public/model_data";
import Utility from "../../../../utility/utility";
import AppData from "../../../public/const/app_data";
const { ccclass } = cc._decorator;


@ccclass
@moduleInit("ChatShowEmoji")
export default class ChatShowEmoji extends ModuleBase<ChatShowEmojiView, null> {

    _model: ModelBase = new ModelBase()
    _lastPinTime: number = 0
    protected LastSendChatTime: number = 0
    
    emojiList:cc.Node[]=[]
    curmoduleName:string=""
    _lastClickTime:number = 0;

    clickTimes:Map<number,number> = null;

    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/table/chat_emoji/module/public_chat_show_emoji';
        this.viewType = ChatShowEmojiView;
        
    }

    

    onInit(data?) {
        this._model.init(GameServer.instance.netClient)
        this.addEvent();
        this.clickTimes = new Map<number,number>();
    }

    onShow(arg0) {
        super.onShow(arg0)
        this.view.clearAnimtionNode();
        this._lastClickTime = 0;
    }

    onDestroy()
    {

    }
    addEvent() {
        cc.log("eventBind：start")
        this.eventBind("show_emoji_msg", this.getSeatViewInfo)
    }
    
    getSeatViewInfo(moduleName:string,protodata:any,isNet:boolean=true)
    {
        if (!AppData.testMode && ModelData.instance.tableCommonData.isClubTable) {
            return;
        }

        let data = protodata.chatMsg;
        if (data.msgType != 1) {
            return;
        }
       
        this.node.active=true;
        this.curmoduleName = moduleName;

        let items = data.text.split("_")

        let fromPlayerid = Number(items[0]);
        let emojiIndex = items[2];
        let toPlayerid = Number(items[1]);

 

        let curMoude:Module<null,null>=ModuleManager.instance.getModule(this.curmoduleName)
        let sendNode:cc.Node=curMoude.getSeatNodeById(fromPlayerid)
        if (!sendNode) {
            return;
        }

        // if (isNet && fromPlayerid==ModelData.instance.roleData.id) {
        //     return;
        // }

        if (!this.checkCanReceive(toPlayerid)) {
            return;
        }

        let receiveNode=curMoude.getSeatNodeById(toPlayerid)
        if (!receiveNode) {
            return;
        }

        this.view.showEmoji(emojiIndex,sendNode,receiveNode);
    }

    checkCanReceive(id:number){
        let time = this.clickTimes.get(id);
        if (!time) {
            this.clickTimes.set(id,new Date().getTime());
            return true;
        }
        let curTime = new Date().getTime();
        if (curTime - time < 2.2 * 1000) {
            return false;
        }
        this.clickTimes.set(id,curTime);
        return true;
    }
    
    send_chat_request(chatMsgType: number, text: string){
        let chatmsg: ProtoPokerRoom.Room.IChatMsg = {
            msgType: chatMsgType,
            text: text
        }
        let protoData: ProtoPokerRoom.Room.IChatMsgReq = {
            chatMsg: chatmsg
        }
        this._model.sendMsg(NetMsgDataBase.Chat, protoData)
    }

}